import {
    Box,
    Divider,
    Typography,
    useMediaQuery,
} from "@mui/material";
import { useState } from "react";
import style from "./NewsItem.module.scss";

import { Post } from "../../../types/Store/OrganizationStore.types";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules";
import "swiper/css/navigation";
import dayjs from "dayjs";
import { useEditor } from "@tiptap/react";
import StarterKit from "@tiptap/starter-kit";
import {
    RichTextContent,
    RichTextEditorProvider,
} from "mui-tiptap";

export function NewsItem({ post }: { post: Post }) {
    const isMobile = useMediaQuery("(max-width:1100px)");

    const [currentImage, setCurrentImage] = useState(1)

    const editor = useEditor({
        extensions: [StarterKit],
        content: post.text,
        editable: false,
    });

    return (
        <Box key={post.id} sx={{
            width:"100%"
        }}>
            <Box
                sx={{
                    width: "100%",
                }}
            >
                <h2>{post.title}</h2>
                <Typography variant="body2" color="#777">
                    Дата: {dayjs(post.created_at).format("DD.MM.YYYY")}
                </Typography>
                {/* <TextExpander children={<p>{post.text}</p>} /> */}
                <RichTextEditorProvider editor={editor}>
                    <RichTextContent></RichTextContent>
                </RichTextEditorProvider>
                {post.photos.length > 0 && (
                    <Box
                        sx={{
                            position: "relative",
                        }}
                    >
                        <p
                            style={{
                                position: "absolute",
                                top: "10px",
                                right: "10px",
                                zIndex: 2000,
                                color: "white",
                                fontSize: "18px",
                                fontWeight: "bold",
                                background: "rgba(0,0,0,0.5)",
                                padding: "4px 8px",
                                borderRadius: "4px",
                                margin: 0,
                            }}
                        >
                            {currentImage}/{post.photos.length}
                        </p>
                        <Swiper
                            pagination
                            modules={[Pagination, Navigation]}
                            slidesPerView={1}
                            spaceBetween={20}
                            loop
                            style={{
                                marginTop: "8px",
                                minWidth: "100%",
                            }}
                            onSlideChange={(swiper: any) => setCurrentImage(swiper.realIndex + 1)}
                        >
                            {post.photos.map((n) => {
                                return (
                                    <SwiperSlide className={style.news__image}>
                                        <img
                                            src={n.url}
                                            style={{
                                                minWidth: "100%",
                                                width: "100%",
                                                maxHeight: "600px",
                                                objectFit: "cover",
                                                zIndex: 1,
                                            }}
                                        />
                                    </SwiperSlide>
                                );
                            })}
                        </Swiper>
                    </Box>
                )}
            </Box>
            <Divider
                sx={{
                    marginTop: "16px",
                    marginLeft: isMobile ? "-24px" : "-240px",
                    marginRight: isMobile ? "-24px" : "-240px",
                }}
            />
        </Box>
    );
}
